;(function (module) {
  'use strict'
  module.controller('PhoneController', [
    '$scope',
    '$http',
    '$state',
    '$stateParams',
    'socket',
    'socketLogin',
    'authService',
    'conversationService',
    'tripsDashBoard',
    'progressBar',
    'ngDialog',
    'commonDialog',
    'commonDialogMessage',
    'currency',
    function (
      $scope,
      $http,
      $state,
      $stateParams,
      socket,
      socketLogin,
      authService,
      conversationService,
      tripsDashBoard,
      progressBar,
      ngDialog,
      commonDialog,
      commonDialogMessage,
      currency,
    ) {
      var progress = progressBar.getProgressBar()
      //Helper private functions
      function getFlightContext(bookingId) {
        tripsDashBoard.getFlightsDashById(bookingId).then(
          function (flights) {
            let contextData = flights.data
            let statusColor = '#000000' //black
            let flightStatus = 'scheduled'
            let dateTime = new Date()
            let arrivalTime = moment(contextData.ArrivalDateTime).format(
              'MM-DD-YYYY h:mm:ss',
            )
            let currentDateTime = moment(dateTime).format('MM-DD-YYYY h:mm:ss')
            if (contextData.FlightStat !== null) {
              let departureTime = moment(contextData.DepartureDateTime).format(
                'MM-DD-YYYY h:mm:ss',
              )
              let estimatedDeparuteTime = moment(
                contextData.FlightStat.EstimatedDeparture,
              ).format('MM-DD-YYYY h:mm:ss')
              let estimatedArrival = moment(
                contextData.FlightStat.EstimatedArrival,
              ).format('MM-DD-YYYY h:mm:ss')
              statusColor =
                departureTime === estimatedDeparuteTime ||
                estimatedDeparuteTime < departureTime
                  ? '#3d9400'
                  : estimatedDeparuteTime > departureTime
                  ? '#cc0000'
                  : statusColor
              flightStatus =
                departureTime === estimatedDeparuteTime ||
                estimatedDeparuteTime < departureTime
                  ? 'on time'
                  : estimatedDeparuteTime > departureTime
                  ? 'delayed'
                  : currentDateTime > estimatedArrival
                  ? 'past flight'
                  : flightStatus
            }
            if (contextData.Cancelled === true) {
              statusColor = '#cc0000' //red
              flightStatus = 'cancelled'
            }
            if (
              contextData.FlightStat === null &&
              currentDateTime > arrivalTime
            ) {
              flightStatus = 'past flight'
            }
            $scope.flightContext = {
              statusColor: statusColor,
              flightStatus: flightStatus,
              estimatedDeparture:
                contextData.FlightStat !== null &&
                contextData.FlightStat.EstimatedDeparture !== null
                  ? contextData.FlightStat.EstimatedDeparture
                  : contextData.DepartureDateTime,
              estimatedArrival:
                contextData.FlightStat !== null &&
                contextData.FlightStat.EstimatedArrival !== null
                  ? contextData.FlightStat.EstimatedArrival
                  : contextData.ArrivalDateTime,
              pnr: contextData.Pnr,
              depart:
                contextData.DepartureName +
                ' (' +
                contextData.DepartureAirport +
                ')',
              arrival:
                contextData.ArrivalName +
                ' (' +
                contextData.ArrivalAirport +
                ')',
              departureName: contextData.DepartureName,
              departureAirport: contextData.DepartureAirport,
              departureDateTime: moment(contextData.DepartureDateTime).format(
                'MM-DD-YYYY h:mm:ss',
              ),
              departureGate:
                contextData.FlightStat !== null &&
                contextData.FlightStat.DepartureGate !== null
                  ? contextData.FlightStat.DepartureGate
                  : '-',
              departureTerminal:
                contextData.FlightStat !== null &&
                contextData.FlightStat.DepartureTerminal !== null
                  ? contextData.FlightStat.DepartureTerminal
                  : '-',
              startDate: contextData.DepartureDateTime,
              endDate: contextData.ArrivalDateTime,
              arrivalName: contextData.ArrivalName,
              arrivalAirport: contextData.ArrivalAirport,
              arrivalDateTime: moment(contextData.ArrivalDateTime).format(
                'MM-DD-YYYY h:mm:ss',
              ),
              arrivalGate:
                contextData.FlightStat !== null &&
                contextData.FlightStat.ArrivalGate !== null
                  ? contextData.FlightStat.ArrivalGate
                  : '-',
              arrivalTerminal:
                contextData.FlightStat !== null &&
                contextData.FlightStat.ArrivalTerminal !== null
                  ? contextData.FlightStat.ArrivalTerminal
                  : '-',
              operatingAirline: contextData.OperatingAirline,
              flightNumber: contextData.FlightNumber,
              duration: contextData.Duration,
              bookingSource: contextData.BookingSource,
              confirmation: contextData.ConfirmationNumber,
              cabin: contextData.Cabin,
              bookingClass: contextData.BookingClass,
              numberInParty: contextData.NumberInParty,
              airTravelers: contextData.AirReservation.AirTravelers,
              comment: contextData.AirReservation.Comment,
              seats: contextData.Seats,
              totalCharge:
                currency.getCurrencySymbol(
                  contextData.AirReservation.CurrencyCode,
                ) + contextData.AirReservation.TotalFare,
              lastUpdated: moment(contextData.Updated).format(
                'MM-DD-YYYY h:mm:ss',
              ),
              isDeleted: contextData.Deleted ? 'Yes' : 'No',
              vendor: contextData.Vendor,
            }
          },
          function (err) {
            if (err.status != 401) {
              ngDialog.open({
                template: 'templates/partials/viewErrorMsg.html',
                className: 'ngdialog-theme-plain',
                controller: [
                  '$scope',
                  function ($scope) {
                    $scope.errMsg = `<p>${err.statusText}</p>`
                    $scope.errTitle = 'Phone History Error'
                  },
                ],
              })
            }
          },
        )
      }

      function getHotelContext(bookingId) {
        const promiseGetHotel = tripsDashBoard.getHotelsDashById(bookingId)
        promiseGetHotel.then(function (hotels) {
          console.log(hotels)
          var contextData = hotels.data
          ;($scope.hotelContext = {
            pnr: contextData.Pnr,
            hotelName: contextData.HotelName,
            address: contextData.Address,
            checkinDate: moment(contextData.CheckInDate).format('MM-DD-YYYY'),
            checkoutDate: moment(contextData.CheckOutDate).format('MM-DD-YYYY'),
            confirmation: contextData.Confirmation,
            bookingSource: contextData.BookingSource,
            guestNames: contextData.GuestNames,
            numberOfRooms: contextData.NumberOfRooms,
            roomType: contextData.RoomType,
            totalCharge:
              contextData.Total +
              ' ' +
              (contextData.CurrencyCode === null
                ? ''
                : contextData.CurrencyCode),
            lastUpdated: moment(contextData.Updated).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            isDeleted: contextData.Deleted === true ? 'Yes' : 'No',
          }),
            function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template:
                    '<p>' +
                    err.statusText +
                    '</p>' +
                    '<div class="ngdialog-buttons">' +
                    '<button angular-ripple type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Ok' +
                    '</button>' +
                    '</div>',
                  className: 'ngdialog-theme-plain',
                  plain: true,
                })
              }
            }
        })
      }

      function getCarContext(bookingId) {
        const promiseGetCar = tripsDashBoard.getCarsDashById(bookingId)
        promiseGetCar.then(function (cars) {
          console.log(cars)
          var contextData = cars.data
          ;($scope.carContext = {
            pnr: contextData.Pnr,
            rentalCompany: contextData.RentalCompany,
            pickupDateTime: moment(contextData.PickUpDateTime).format(
              'MM-DD-YYYY h:mm',
            ),
            pickupLocation: contextData.PickUpLocation,
            pickupLocationIsAirport:
              contextData.PickUpAtAirport === true ? 'Yes' : 'No',
            pickupLocationPhoneNumber: contextData.PickUpLocationPhoneNumber,
            pickupLocationCode: contextData.PickUpLocationCode,
            dropoffDateTime: moment(contextData.DropOffDateTime).format(
              'MM-DD-YYYY h:mm',
            ),
            dropoffLocation: contextData.DropOffLocation,
            dropoffLocationIsAirport:
              contextData.DropOffAtAirport === true ? 'Yes' : 'No',
            dropoffLocationPhoneNumber: contextData.DropOffLocationPhoneNumber,
            dropoffLocationCode: contextData.DropOffLocationCode,
            carModel: contextData.CarModel,
            confirmation: contextData.Confirmation,
            bookingSource: contextData.BookingSource,
            totalCharge:
              contextData.TotalCharge +
              ' ' +
              (contextData.CurrencyCode === null
                ? ''
                : contextData.CurrencyCode),
            lastUpdated: moment(contextData.Updated).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            isDeleted: contextData.Deleted === true ? 'Yes' : 'No',
          }),
            function (err) {
              if (err.status != 401) {
                ngDialog.open({
                  template:
                    '<p>' +
                    err.statusText +
                    '</p>' +
                    '<div class="ngdialog-buttons">' +
                    '<button angular-ripple type="button" class="ngdialog-button ngdialog-button-secondary" ng-click="closeThisDialog(0)">Ok' +
                    '</button>' +
                    '</div>',
                  className: 'ngdialog-theme-plain',
                  plain: true,
                })
              }
            }
        })
      }

      function generateFlightContext(flightContext) {
        return flightContext.map(function (contextData) {
          let statusColor = '#000000' //black
          let flightStatus = 'scheduled'
          let currentDateTime = new Date()
          let arrivalTime = moment(contextData.ArrivalDateTime).format(
            'MM-DD-YYYY h:mm:ss',
          )
          currentDateTime = moment(currentDateTime).format('MM-DD-YYYY h:mm:ss')
          if (contextData.FlightStat !== null) {
            let departureTime = moment(contextData.DepartureDateTime).format(
              'MM-DD-YYYY h:mm:ss',
            )
            let estimatedDeparuteTime = moment(
              contextData.FlightStat.EstimatedDeparture,
            ).format('MM-DD-YYYY h:mm:ss')
            let estimatedArrival = moment(
              contextData.FlightStat.EstimatedArrival,
            ).format('MM-DD-YYYY h:mm:ss')
            statusColor =
              departureTime === estimatedDeparuteTime ||
              estimatedDeparuteTime < departureTime
                ? '#3d9400'
                : estimatedDeparuteTime > departureTime
                ? '#cc0000'
                : statusColor
            flightStatus =
              departureTime === estimatedDeparuteTime ||
              estimatedDeparuteTime < departureTime
                ? 'on time'
                : estimatedDeparuteTime > departureTime
                ? 'delayed'
                : currentDateTime > estimatedArrival
                ? 'past flight'
                : flightStatus
          }
          if (contextData.Cancelled === true) {
            statusColor = '#cc0000' //red
            flightStatus = 'cancelled'
          }
          if (
            contextData.FlightStat === null &&
            currentDateTime > arrivalTime
          ) {
            flightStatus = 'past flight'
          }
          return {
            statusColor: statusColor,
            flightStatus: flightStatus,
            estimatedDeparture:
              contextData.FlightStat !== null &&
              contextData.FlightStat.EstimatedDeparture !== null
                ? contextData.FlightStat.EstimatedDeparture
                : contextData.DepartureDateTime,
            estimatedArrival:
              contextData.FlightStat !== null &&
              contextData.FlightStat.EstimatedArrival !== null
                ? contextData.FlightStat.EstimatedArrival
                : contextData.ArrivalDateTime,
            pnr: contextData.Pnr,
            bookingTypeName: 'A',
            bookingType: 'Airline Reservation',
            depart:
              contextData.DepartureName +
              ' (' +
              contextData.DepartureAirport +
              ')',
            arrival:
              contextData.ArrivalName + ' (' + contextData.ArrivalAirport + ')',
            departureName: contextData.DepartureName,
            departureAirport: contextData.DepartureAirport,
            departureDateTime: moment(contextData.DepartureDateTime).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            departureGate:
              contextData.FlightStat !== null &&
              contextData.FlightStat.DepartureGate !== null
                ? contextData.FlightStat.DepartureGate
                : '-',
            departureTerminal:
              contextData.FlightStat !== null &&
              contextData.FlightStat.DepartureTerminal !== null
                ? contextData.FlightStat.DepartureTerminal
                : '-',
            startDate: contextData.DepartureDateTime,
            endDate: contextData.ArrivalDateTime,
            arrivalName: contextData.ArrivalName,
            arrivalAirport: contextData.ArrivalAirport,
            arrivalDateTime: moment(contextData.ArrivalDateTime).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            arrivalGate:
              contextData.FlightStat !== null &&
              contextData.FlightStat.ArrivalGate !== null
                ? contextData.FlightStat.ArrivalGate
                : '-',
            arrivalTerminal:
              contextData.FlightStat !== null &&
              contextData.FlightStat.ArrivalTerminal !== null
                ? contextData.FlightStat.ArrivalTerminal
                : '-',
            operatingAirline: contextData.OperatingAirline,
            flightNumber: contextData.FlightNumber,
            duration: contextData.Duration,
            bookingSource: contextData.BookingSource,
            confirmation: contextData.ConfirmationNumber,
            cabin: contextData.Cabin,
            bookingClass: contextData.BookingClass,
            numberInParty: contextData.NumberInParty,
            airTravelers: contextData.AirReservation.AirTravelers,
            comment: contextData.AirReservation.Comment,
            seats: contextData.Seats,
            totalCharge:
              currency.getCurrencySymbol(
                contextData.AirReservation.CurrencyCode,
              ) + contextData.AirReservation.TotalFare,
            lastUpdated: moment(contextData.Updated).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            isDeleted: contextData.Deleted ? 'Yes' : 'No',
            vendor: contextData.Vendor,
          }
        })
      }

      function generateCarContext(carContext) {
        return carContext.map(function (contextData) {
          return {
            bookingTypeName: 'C',
            bookingType: 'Car Reservation',
            pnr: contextData.Pnr,
            startDate: contextData.PickUpDateTime,
            rentalCompany: contextData.RentalCompany,
            pickupDateTime: moment(contextData.PickUpDateTime).format(
              'MM-DD-YYYY h:mm',
            ),
            pickupLocation: contextData.PickUpLocation,
            pickupLocationIsAirport:
              contextData.PickUpAtAirport === true ? 'Yes' : 'No',
            pickupLocationPhoneNumber: contextData.PickUpLocationPhoneNumber,
            pickupLocationCode: contextData.PickUpLocationCode,
            dropoffDateTime: moment(contextData.DropOffDateTime).format(
              'MM-DD-YYYY h:mm',
            ),
            dropoffLocation: contextData.DropOffLocation,
            dropoffLocationIsAirport:
              contextData.DropOffAtAirport === true ? 'Yes' : 'No',
            dropoffLocationPhoneNumber: contextData.DropOffLocationPhoneNumber,
            dropoffLocationCode: contextData.DropOffLocationCode,
            carModel: contextData.CarModel,
            confirmation: contextData.Confirmation,
            bookingSource: contextData.BookingSource,
            totalCharge:
              contextData.TotalCharge +
              ' ' +
              (contextData.CurrencyCode === null
                ? ''
                : contextData.CurrencyCode),
            lastUpdated: moment(contextData.Updated).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            isDeleted: contextData.Deleted === true ? 'Yes' : 'No',
          }
        })
      }

      function generateHotelContext(hotelContext) {
        return hotelContext.map(function (contextData) {
          return {
            bookingTypeName: 'H',
            bookingType: 'Hotel Reservation',
            pnr: contextData.Pnr,
            startDate: contextData.CheckInDate,
            hotelName: contextData.HotelName,
            address: contextData.Address,
            checkinDate: moment(contextData.CheckInDate).format('MM-DD-YYYY'),
            checkoutDate: moment(contextData.CheckOutDate).format('MM-DD-YYYY'),
            confirmation: contextData.Confirmation,
            bookingSource: contextData.BookingSource,
            guestNames: contextData.GuestNames,
            numberOfRooms: contextData.NumberOfRooms,
            roomType: contextData.RoomType,
            totalCharge:
              contextData.Total +
              ' ' +
              (contextData.CurrencyCode === null
                ? ''
                : contextData.CurrencyCode),
            lastUpdated: moment(contextData.Updated).format(
              'MM-DD-YYYY h:mm:ss',
            ),
            isDeleted: contextData.Deleted === true ? 'Yes' : 'No',
          }
        })
      }

      function getAllContexts(bookingId) {
        $scope.contextList = []
        let tripFlightContext = []
        let tripCarContext = []
        let tripHotelContext = []
        tripsDashBoard.getTripsDashbyId(topic.bookingId).then(function (trips) {
          tripFlightContext = trips.data.Flights
          tripCarContext = trips.data.Cars
          tripHotelContext = trips.data.Hotels
          let flightList = []
          let hotelList = []
          let carList = []
          if (!!tripFlightContext.length) {
            flightList = generateFlightContext(tripFlightContext)
          }
          if (!!tripCarContext.length) {
            carList = generateCarContext(tripCarContext)
          }
          if (!!tripHotelContext.length) {
            hotelList = generateHotelContext(tripHotelContext)
          }
          $scope.contextList = [flightList, carList, hotelList].reduce(
            function (prevData, currData) {
              return prevData.concat(currData)
            },
            [],
          )
          let sortByDateAsc = function (a, b) {
            let firstStartDate = moment(a.startDate).format('MM-DD-YYYY')
            let secondStartDate = moment(b.startDate).format('MM-DD-YYYY')
            if (firstStartDate > secondStartDate) {
              return 1
            } else if (firstStartDate < secondStartDate) {
              return -1
            } else if (firstStartDate === secondStartDate) {
              if (a.bookingTypeName === 'A') {
                return -1
              } else if (b.bookingTypeName === 'A') {
                return 1
              } else if (
                a.bookingTypeName === 'H' &&
                b.bookingTypeName === 'C'
              ) {
                return -1
              } else if (
                a.bookingTypeName === 'C' &&
                b.bookingTypeName === 'H'
              ) {
                return 1
              } else {
                return 0
              }
            }
          }
          $scope.contextList.sort(sortByDateAsc)
        })
      }
      //init of page
      console.log($stateParams) //{fromNumber: fromNumber, firstName: firstName, lastName: lastName}
      console.log($state.params) //{fromNumber:"13462764357"}
      console.log(authService.getLoginMember())
      var fromNumber = $state.params.fromNumber
      var firstName = $state.params.travelerFirstName
      var lastName = $state.params.travelerLastName
      var organizationName = $state.params.travelerOrganizationName
      var topic = $state.params.topic
      if (fromNumber) {
        $scope.isInConversation = true
        $scope.conversationTitle =
          'Assisting ' +
          firstName +
          ' ' +
          lastName +
          ' (' +
          fromNumber +
          ')' +
          ' ' +
          organizationName
        $scope.firstName = firstName
        $scope.lastName = lastName
        $scope.fromNumber = fromNumber
        $scope.organizationName = organizationName
        //context
        if (topic) {
          if (topic.bookingType === 'FlightViewModel') {
            $scope.bookingType = 'Airline Reservation'
            getFlightContext(topic.bookingId)
          } else if (topic.bookingType === 'HotelViewModel') {
            $scope.bookingType = 'Hotel Reservation'
            getHotelContext(topic.bookingId)
          } else if (topic.bookingType === 'CarViewModel') {
            $scope.bookingType = 'Car Reservation'
            getCarContext(topic.bookingId)
          } else if (topic.bookingType === 'TripViewModel') {
            $scope.bookingType = 'Trip'
            getAllContexts(topic.bookingId)
          }
        }
      } else {
        $scope.isInConversation = false
        $scope.conversationTitle = 'You are not assisting'
      }
      //on socket event
      //on user's action
      $scope.finishConversation = function () {
        var confirmMessage =
          'This is to confirm that you finish assisting the traveler. If so, you can click on the Yes button.  This tab will be closed and future messages from the traveler will not show up here.'
        ngDialog
          .openConfirm({
            template: confirmMessage + commonDialog.confirmDialog,
            className: 'ngdialog-theme-plain',
            plain: true,
          })
          .then(function (value) {
            var loginMember = authService.getLoginMember()
            progress.start()
            $http.post('/finish', {
              fromNumber: fromNumber,
              travelAgentEmail: loginMember.Email,
            })
            $state.go(
              'app',
              {},
              {
                reload: true,
              },
            )
            progress.complete()
          })
      }
    },
  ])
})(angular.module('obex'))



// WEBPACK FOOTER //
// ./client/js/controllers/phoneController.js